module.exports = __webpack_public_path__ + "img/5.55d95b42.png";